document.addEventListener('DOMContentLoaded', function() {
    const popupBtn = document.querySelector('.popup-newsletter__btn');
    const popupInner = document.querySelector('.popup-newsletter__inner');
    const popupClose = document.querySelector('.popup-newsletter__close');
    
    // Variable pour tracker si le close a été cliqué
    let closeClicked = false;

    // Fonction pour fermer la popup
    function closePopup() {
        if (popupInner) {
            popupInner.classList.remove('popup-newsletter__inner--open');
        }
            
        // Marquer que le close a été cliqué et cacher le bouton
        if (!closeClicked) {
            closeClicked = true;
            // Sauvegarder dans un cookie que l'utilisateur a fermé la popup
            document.cookie = "popupClosed=true; path=/";
            if (popupBtn) {
            popupBtn.style.display = 'none';
            }
        }
    }

    // Ouvrir la popup
    if (popupBtn && popupInner) {
        popupBtn.addEventListener('click', function(e) {
            e.preventDefault();
            popupInner.classList.add('popup-newsletter__inner--open');
        });
    }

    // Vérifier si le cookie popupClosed existe
    if (document.cookie.includes('popupClosed=true')) {
        closePopup();
    } else {
        if (popupBtn) {
            popupBtn.style.opacity = '1';
        }
    }

    // Fermer la popup avec le bouton close
    if (popupClose && popupInner) {
        popupClose.addEventListener('click', function(e) {
            e.preventDefault();
            closePopup();
        });
    }

    // Fermer la popup en cliquant en dehors
    document.addEventListener('click', function(e) {
        if (popupInner && popupInner.classList.contains('popup-newsletter__inner--open')) {
            if (!popupInner.contains(e.target) && !popupBtn.contains(e.target)) {
                closePopup();
            }
        }
    });
});
